import { useSelector } from 'react-redux';

export function useSamsaraSelector() {
  return useSelector((state) => state.samsaraData || {});
}
